import React, { useState, useContext } from "react";
import { TextField, Button, Container, Typography, Box, Alert } from "@mui/material";
import { AuthContext } from "./AuthContext";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useContext(AuthContext);

  const handleLogin = async () => {
    try {
      await login(username, password);
    } catch (err) {
      setError(err.message);
    }
  };
  

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 10, direction: "rtl" }}>
      <Typography variant="h4" sx={{ mb: 3 }}>ورود به سیستم اسکن</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField label="نام کاربری" variant="outlined" fullWidth value={username} onChange={(e) => setUsername(e.target.value)} />
        <TextField label="رمز عبور" type="password" variant="outlined" fullWidth value={password} onChange={(e) => setPassword(e.target.value)} />
        <Button variant="contained" color="primary" onClick={handleLogin}>ورود</Button>
      </Box>
    </Container>
  );
};

export default Login;
